import { Spinner } from "@/components/ui";

/**
 * Workshop: Execution status bar — shows active execution indicators.
 * Uses hardcoded mock state instead of companion store.
 */

interface ExecutionStatusBarProps {
  /** Number of running agents (0 hides the bar) */
  runningCount?: number;
  "data-testid"?: string;
}

export function ExecutionStatusBar({
  runningCount = 1,
  "data-testid": testId = "execution-status-bar",
}: ExecutionStatusBarProps) {
  if (runningCount === 0) return null;

  return (
    <div
      className="flex items-center gap-2 border-t border-border bg-surface/50 px-4 py-1.5"
      data-testid={testId}
    >
      <Spinner className="h-3 w-3 text-accent" />
      <span className="text-xs text-muted">
        {runningCount === 1
          ? "Agent is thinking..."
          : `${runningCount} agents working...`}
      </span>
    </div>
  );
}

export type { ExecutionStatusBarProps };
